import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { TransitMapPageRoutingModule } from './transit-map-routing.module';

import { TransitMapPage } from './transit-map.page';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, TransitMapPageRoutingModule, TranslateModule.forChild()],
  declarations: [TransitMapPage]
})
export class TransitMapPageModule {}
